import { render, staticRenderFns } from "./LeatherPage.vue?vue&type=template&id=3f36f878"
import script from "./LeatherPage.vue?vue&type=script&lang=js"
export * from "./LeatherPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports